$(document).ready(function () {

  const steps1 = [];
  const steps2 = [];
  
  for (let i = 1000; i <= 5250; i += 250) {
    steps1.push(i);
  }
  steps1.push(5400);

  for (let i = 1000; i <= 3000; i += 250) {
    steps2.push(i);
  }

  function findClosest(val, steps) {
    return steps.reduce((prev, curr) =>
      Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev
    );
  }

  function findClosestUp(val, steps) {
    const filtered = steps.filter(step => step >= val);
    if (filtered.length === 0) return null;
    return filtered.reduce((prev, curr) => curr < prev ? curr : prev);
  }

  let isUpdating = false;

  function updateComboValue(triggerId, otherId) {
    if (isUpdating) return;

    isUpdating = true;

    let stepsTrigger = triggerId === 'number-1' ? steps1 : steps2;
    let stepsOther = otherId === 'number-1' ? steps1 : steps2;

    let val1 = parseFloat($('#' + triggerId).val());
    let val2 = parseFloat($('#' + otherId).val());

    if (!isNaN(val1)) {
      val1 = findClosestUp(val1, stepsTrigger);
      $('#' + triggerId).val(val1);
      document.querySelector('#' + triggerId).dispatchEvent(new Event('change'));
    }

    if (isNaN(val2)) {
      val2 = stepsOther[0];
      $('#' + otherId).val(val2);
      document.querySelector('#' + otherId).dispatchEvent(new Event('change'));
    } else {
      val2 = findClosestUp(val2, stepsOther);
      $('#' + otherId).val(val2);
      document.querySelector('#' + otherId).dispatchEvent(new Event('change'));
    }

    const val1Combo = parseFloat($('#number-1').val());
    const val2Combo = parseFloat($('#number-2').val());
    const combo = val1Combo + 'mm * ' + val2Combo + 'mm';

    /*const $select = $('select[name="curtain-area"]');
    const $option = $select.find('option[value="' + combo + '"]');*/
    const $option = $('input[type="radio"][name="curtain-area"][value="' + combo + '"]');

    if ($option.length) {
      // $select.val(combo).change();
      $option.prop('checked', true);
      // document.querySelector('input[type="radio"][name="curtain-area"]').dispatchEvent(new Event('change'));
      $option[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    isUpdating = false;
  }

  $(document).on('change', '#number-1', function () {
    updateComboValue('number-1', 'number-2');
  });

  $(document).on('change', '#number-2', function () {
    updateComboValue('number-2', 'number-1');
  });

  /**/
  const target = document.querySelector('span[data-gpo-product-unit-price]');
  
  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        // console.log('内容变了:', $(target).text());
        let text = $(target).text();
        let match = text.match(/[\d,.]+/);
        let number = parseFloat(match[0].replace(/,/g, ''));
        let quarter = Math.ceil((number / 4) * 100) / 100;
        $('.afterpay-info.curtain-product strong').eq(0).text( '$' + quarter.toFixed(2) );
      }
    }
  });
  
  observer.observe(target, {
    childList: true,       // 监听子节点变化（如 <span>test</span> 变为 <span>new</span>）
    characterData: true,   // 监听文本变化
    subtree: true          // 递归监听（必要）
  });

  

});
